import { gateway } from "../../../gateway";
import { AppConfig } from "../interfaces/appIntegration.interfaces";

export const getAllIntegrations = async (): Promise<AppConfig[]> => {
    const response = await gateway.get("/app-center-integrations/self")
    return response.data?.data || response.data;
};